export const vatPatterns = {
  'Austria': /^ATU\d{8}$/,
  'Belgium': /^BE[0-1]{1}\d{9}$/,
  'Bulgaria': /^BG\d{9,10}$/,
  'Croatia': /^HR\d{11}$/,
  'Cyprus': /^CY\d{8}[A-Z]$/,
  'Czech Republic': /^CZ\d{8,10}$/,
  'Denmark': /^DK\d{8}$/,
  'Estonia': /^EE\d{9}$/,
  'Finland': /^FI\d{8}$/,
  'France': /^FR[A-Z0-9]{2}\d{9}$/,
  'Germany': /^DE\d{9}$/,
  'Greece': /^EL\d{9}$/,
  'Hungary': /^HU\d{8}$/,
  'Ireland': /^IE\d{7}[A-Z]{1,2}$/,
  'Italy': /^IT\d{11}$/,
  'Latvia': /^LV\d{11}$/,
  'Lithuania': /^LT\d{9,12}$/,
  'Luxembourg': /^LU\d{8}$/,
  'Malta': /^MT\d{8}$/,
  'Netherlands': /^NL\d{9}B\d{2}$/,
  'Poland': /^PL\d{10}$/,
  'Portugal': /^PT\d{9}$/,
  'Romania': /^RO\d{2,10}$/,
  'Slovakia': /^SK\d{10}$/,
  'Slovenia': /^SI\d{8}$/,
  'Spain': /^ES[A-Z0-9]\d{7}[A-Z0-9]$/,
  'Sweden': /^SE\d{12}$/,
  'United Kingdom': /^GB\d{9}$/
};

export const validateVatNumber = (vatNumber: string, country: string): boolean => {
  const pattern = vatPatterns[country as keyof typeof vatPatterns];
  if (!pattern) return true; // Skip validation if country pattern not found
  
  return pattern.test(vatNumber.toUpperCase().replace(/\s/g, ''));
};

export const formatVatNumber = (vatNumber: string): string => {
  return vatNumber.toUpperCase().replace(/\s/g, '');
};